import React, { useState } from 'react'
import './appoinment.css'
import emailjs from '@emailjs/browser';
import { useNavigate } from "react-router-dom";

export default function Appoinment() {
  const [data, setData] = useState({
    name: '',
    number: '',
    mail: '',
    message: '',
  });
  const Nav=useNavigate()
  const { name,mail, message } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({...prevData,[name]: value,}));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    emailjs
      .sendForm('service_wp5fg25', 'template_rlt0bfg',e.target, {
        publicKey: '9oLRZGqYbI-iCb1mM',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          alert('Thanks for Booking Appionment')
          Nav('/')
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
      e.target.reset()
  };
  return (
    <div className='appoint'>
      <div className='leftside'>
        <form onSubmit={handleSubmit} className='forms'>
        <p>Name</p>
        <input  value={name} name='name' onChange={handleChange} className='inputs' type='text' placeholder='Name' required/>
        <br/>
        <p>Email Address</p>
        <input   value={mail} name='mail' onChange={handleChange} className='inputs' type='text' placeholder='Email' required/>
        <p>Leave us a Message</p>
        <textarea  value={message} name='message' onChange={handleChange} className='textarea' type='textarea' placeholder='Message' required/>
        <button className='book'>Book Now</button>
        <br/>
      </form>
      </div>
      <div className='rightside'>
        <img className='sideimg' src='img2.jpeg' alt=''/>
      </div>
    </div>
  )
}
